import { render, staticRenderFns } from "./PositionIcon.vue?vue&type=template&id=0ba4161b"
import script from "./PositionIcon.vue?vue&type=script&lang=js"
export * from "./PositionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports